var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmitInline',{attrs:{"element":_vm.inline,"entryItems":_vm.entryItems},on:{"updated":function($event){return _vm.updated($event)}}},[_c('span',{class:_vm.inline.style},[_vm._v(_vm._s(_vm.inline.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }